import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext, useWatch } from 'react-hook-form';

import DropdownMC from '../../../../../components/DropdownMC';
import InputMC from '../../../../../components/InputMC';
import OrderTermsConditions from '../terms-and-conditions/OrderTermsConditions';

import { currencyOptions, statusOptions } from '../../../constants/orderInfo.constants';
import useOrderInfoStep from '../../../hooks/useOrderInfoStep';
import { filterOptions } from '../../../../../../util/filterOptions';

const OrderInfo = ({ channel, action }) => {
  const { t: tCommon } = useTranslation('Common');
  const { t } = useTranslation('Orders');

  const { getValues, setValue, control } = useFormContext();
  const salesChannelIdWatch = useWatch({ name: 'sales_channel_id', control });

  const { agentsOptions, salesChannelsOptions } = useOrderInfoStep({
    channel,
    getValues,
    setValue,
    useWatch,
    control
  });

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <h1 className="tw-font-semibold tw-text-gray-950 tw-text-sm">
        {t('orderInfo.title')}
      </h1>

      <div className="tw-flex tw-flex-col tw-gap-4">
        <div className="tw-flex tw-gap-2">
          <DropdownMC
            search
            useFloatingLabel
            id="currency"
            name="currency"
            label={tCommon('form.currency')}
            options={currencyOptions}
            defaultValue={getValues('currency')}
            filterOption={(s) => filterOptions(s, currencyOptions)}
          />

          <DropdownMC
            useFloatingLabel
            id="status"
            name="status"
            label={tCommon('form.status')}
            options={statusOptions}
            defaultValue={getValues('status')}
          />
        </div>

        <div className="tw-flex tw-gap-2">
          <DropdownMC
            useFloatingLabel
            id="agent_id"
            name="agent_id"
            label={tCommon('form.seller')}
            options={agentsOptions}
            defaultValue={getValues('agent_id')}
          />

          <DropdownMC
            useFloatingLabel
            id="sales_channel_id"
            name="sales_channel_id"
            label={tCommon('form.sales_channel')}
            options={salesChannelsOptions}
            defaultValue={salesChannelIdWatch}
          />
        </div>

        <InputMC
          id="notes"
          name="notes"
          label={tCommon('form.notes')}
          placeholder={tCommon('form.placeholders.orderNotes')}
          className="tw-resize-none tw-w-full !tw-placeholder-gray-400"
          textarea
          useFloatingLabel
        />

        <OrderTermsConditions action={action} />
      </div>
    </div>
  );
};

export default memo(OrderInfo);
